module.exports = __webpack_public_path__ + "static/media/facebook.c32c98ea.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/facebook.svg
// module id = 236
// module chunks = 0